module.exports = __webpack_public_path__ + "static/media/tick-circle.0f9acca3.svg";